import { flow } from 'fp-ts/lib/function';

import { RemoteData } from '@catawiki/runtime-toolkit';

export const constructUrl = (loc: string, asPath: string) =>
  `https://${
    process.env.NEXT_PUBLIC_BASE_DOMAIN || 'www.catawiki.com'
  }/${loc}${asPath}`;

export const nullableData = flow(RemoteData.fromEither, RemoteData.toNullable);
